/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter, StyledHomepage } from '../../../commons/styles/layout';
import themeSettings from '../../../commons/styles/themeSettings.json';
import translation from '../Utils/translation';
import { useNavigate } from "react-router-dom";

import { API_MODULES, IPAddress, API_RUBUSMASTERS } from '../../../commons/api';
import {
  Form,
  Input,
  Select,
  message,
  Button,
  Drawer,
  Upload,
  Modal,
  Tabs,
} from 'antd';
import {
  UpdateMasters,
  CreateMasters,
  getDevicesTypesFileDownloadName,
  getAllSubEquipmentFileDownloadName,
  getAllAttributeFileDownloadName,
  getAllParameterFileDownloadName
} from '../APICalls';
import {
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined
} from '@ant-design/icons';

const { Option } = Select;
const { TabPane } = Tabs;

const APIList = {
  CreateDeviceTypes: `${API_MODULES.DeviceTypesCreate}`,
  UpdateDeviceTypes: `${API_MODULES.DeviceTypesUpdate}`
};

const DeviceTypes = (props) => {
  const [formObject, setFormObject] = useState({});
  // const [ModuleCodes, setModuleCodes] = useState([]);
  // const [SelectedModulesCode, setSelectedModulesCode] = useState('');
  const [list, setList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  // const [module, setModule] = useState(null);
  const [AliasCode, setAliasCode] = useState('');
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [fileDownloadName, setFileDownloadName] = useState('');

  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  const [SubEquipmentFileName, setSubEquipmentFileName] = useState('');

  const [AttributeFileName, setAttributeFileName] = useState('');

  const [ParameterFileName, setParameterFileName] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');


  const hForm = useRef();
  const hRef = useRef();
  const AttributeFormRef = useRef();
  const ParameterFormRef = useRef();
  const navigate = useNavigate();
  useEffect(() => {
    // let path = history.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypes/');
    // let module = path && path[1] ? path[1] : null;
    let searchParams = new URLSearchParams(props.location.search);
    let newParams = Object.fromEntries([...searchParams]);

    // setModule(module);
    setAliasCode(newParams.AliasCode);

    _getList(newParams.AliasCode);
    // ModulesCodeApi();
    getFileDownloadName(newParams.AliasCode);
    getSubEquipmentFileDownloadName(newParams.AliasCode);
    getParameterFileDownloadName(newParams.AliasCode);
    getAttributeFileDownloadName(newParams.AliasCode);

  }, []);

  const _getList = (module) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `${API_RUBUSMASTERS.DT_GET}?SiteId=${siteId}&Status=Active${module && module !== null ? `&ModuleCode=${module}` : ''}${module === null ? `&Type=${'NoModule'}` : ''}`;

    axios.get(url, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((response) => {
        setList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);

  let searchInput;

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          icon={<SearchOutlined style={{ color: 'white' }} />}
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}

          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: () => (
      <SearchOutlined style={{ color: 'white', }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };


  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setFormObject(record);
    setVisible(true);
  };

  const onFinish = async () => {
    let payload = {
      ...await hForm.current.validateFields(),
      ModuleCode: AliasCode
    };

    if (formObject && formObject.Id) {
      let UpdateResponse = await UpdateMasters(
        APIList.UpdateDeviceTypes,
        payload,
        formObject.Id
      );
      message.success(UpdateResponse && UpdateResponse.message);
    } else {
      let CreateResponse = await CreateMasters(APIList.CreateDeviceTypes, payload);
      CreateResponse && message.success(CreateResponse && CreateResponse.message);

    }
    _getList(AliasCode);
    getFileDownloadName(AliasCode);

    hForm.current && hForm.current.setFieldsValue({
      ModuleCode: null,
      Code: null,
      Name: null,
      Description: null,
      DisplayCode: null,
      Status: 'Active'
    });
    setVisible(false);
    setFormObject({});
  };

  // const ModulesCodeApi = () => {
  //    const accessToken = localStorage.get('accessToken');
  //    const siteId = localStorage.get('currentSite');

  //    axios.get(`${API_MODULES.ModulesGet}?SiteId=${siteId}`, { headers: { Authorization: `Bearer ${accessToken}` } })
  //      .then((response) => {
  //        setModuleCodes(response.data);
  //      })
  //      .catch(() => {});
  // };

  const onClose = () => {
    hForm.current && hForm.current.setFieldsValue({
      ModuleCode: null,
      Code: null,
      Name: null,
      Description: null,
      DisplayCode: null,
      Status: 'Active'
    });
    setVisible(false);
    setFormObject({});
  };

  // const ModuleCodeSelection = (value) => {
  //    setSelectedModulesCode(value);
  // };

  const openDrawer = () => {
    hForm.current && hForm.current.setFieldsValue({
      ModuleCode: null,
      Code: null,
      Name: null,
      Description: null,
      DisplayCode: null,
      Status: 'Active'
    });

    let formObjectInit = {
      ModuleCode: null,
      Code: null,
      Name: null,
      Description: null,
      DisplayCode: null,
      Status: 'Active'
    };

    setFormObject(formObjectInit);
    setVisible(true);
  };

  const openModal = () => {
    setModalVisible(true);
  };

  const OnNextClick = (record) => {
    navigate(`/rubus/CustomerAssetDevice/DeviceTypesChildren/${record.AliasCode}?type=deviceTypes`);
  };

  const getFileDownloadName = async (module) => {
    let fileDownloadNameResponse = await getDevicesTypesFileDownloadName(module);
    setFileDownloadName(fileDownloadNameResponse && fileDownloadNameResponse.file ? fileDownloadNameResponse.file : '');
  };

  const getSubEquipmentFileDownloadName = async (module) => {
    let SubEquipmentFileNameResponse = await getAllSubEquipmentFileDownloadName(module);
    setSubEquipmentFileName(SubEquipmentFileNameResponse && SubEquipmentFileNameResponse.file ? SubEquipmentFileNameResponse.file : '');
  };

  const getAttributeFileDownloadName = async (module) => {
    let AttributeFileNameResponse = await getAllAttributeFileDownloadName(module);
    setAttributeFileName(AttributeFileNameResponse && AttributeFileNameResponse.file ? AttributeFileNameResponse.file : '');
    // Set Attribute file name in state
  };

  const getParameterFileDownloadName = async (module) => {
    let ParameterFileNameResponse = await getAllParameterFileDownloadName(module);
    setParameterFileName(ParameterFileNameResponse && ParameterFileNameResponse.file ? ParameterFileNameResponse.file : '');
    // Set Parameter file name in state
  };
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  let colum = [
    { key: 'S No', value: 'S No' },
    { key: 'Device Type Code', value: 'Code' },
    { key: 'Device Type Name', value: 'Name' },
    { key: 'Device Type Description', value: 'Description' },
    { key: 'Status', value: 'Status' }
  ];
  const columns =
    colum && Array.isArray(colum)
      ? colum
        // .filter((col) => col !== 'Id' && col !== 'SiteId' && col !== 'AliasCode')
        .map((field) => {
          return {
            title: field.key,
            dataIndex: field.value,
            key: field.value,
            ...getColumnSearchProps(field.value)
          };
        })
      : [];
  const finalColumns = [
    ...columns,
    {
      title: translation(translationCache, 'Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_text, record) => (
        <span>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => _editRecord(record)}

          />

          <Button
            type="primary"
            onClick={() => OnNextClick(record)}
            style={{ marginLeft: '10px' }}
          >
            <span>{translation(translationCache, 'Next')}</span>
          </Button>
        </span>
      )
    }
  ];
  return (
    <StyledHomepage>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Button type='primary' style={{ marginRight: '10px' }} >
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined />
            <span style={{ marginRight: '10px' }}>
              {translation(translationCache, 'Download')}
            </span>
          </a>
        </Button>
        <Button type='primary' style={{ marginRight: '10px' }}>
          <Upload
            multiple={false}
            style={{ marginRight: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                getFileDownloadName(AliasCode);
                _getList(AliasCode);
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`/api/rubusMaster/upload/deviceTypes?SiteId=${siteId}${AliasCode && AliasCode !== null ? `&ModuleCode=${AliasCode}` : ''}${AliasCode === null ? `&Type=${'NoModule'}` : ''}`}
            headers={{
              Authorization: `Bearer ${localStorage.get('accessToken')}`
            }}
            showUploadList={false}
          >
            <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>{translation(translationCache, 'Upload')}</span>
          </Upload>
        </Button>
        <Button onClick={openModal} style={{ marginRight: '10px' }}>
          {translation(translationCache, 'Upload Data')}
        </Button>
        <Button onClick={openDrawer}>
          <PlusOutlined /> {translation(translationCache, 'Add DeviceTypes')}
        </Button>
      </div>

      <Tabs type="card" theme={themeSettings}>
        <TabPane tab={translation(translationCache, 'DeviceTypes')} key="List">
          <StyledTable size="small"
            columns={finalColumns}
            dataSource={list}
            pagination={
              list.length > 10 ? { pageSize: '10' } : false
            }
            style={{ marginTop: '20px' }}
          />
        </TabPane>
      </Tabs>

      {/* Modal for Upload and Download */}
      <Modal
        width={'900'}
        title={translation(translationCache, 'Upload and Download Data')}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="back" onClick={() => setModalVisible(false)}>
            {translation(translationCache, 'Cancel')}
          </Button>
        ]}
      >
        <Tabs
          type="card"
          style={{ marginTop: '20px', marginBottom: '30px', color: 'black' }}
          theme={themeSettings}
        >
          <TabPane tab={translation(translationCache, 'SubEquipments')} key="SubEquipments">
            <Form
              name="SubEquipmentForm"
              ref={hRef}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '130px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <>
                  <Form.Item
                    name="Download SubEquipments"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'DownloadSubEquipments')}
                  >
                    <a href={`${IPAddress.LOCAL}${SubEquipmentFileName}`}>
                      <DownloadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black' }}>Download</span>
                    </a>
                  </Form.Item>

                  <Form.Item
                    name="Upload SubEquipments"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'UploadSubEquipments')}
                  >
                    <Upload
                      multiple={false}
                      style={{ marginRight: '10px', color: 'white' }}
                      onChange={async (info) => {
                        if (info.file.status === 'done') {
                          message.success(info.file.response.message);
                          getSubEquipmentFileDownloadName(AliasCode);
                          setModalVisible(false);
                        } else if (info.file.status === 'error') {
                          message.error(info.file.response.message);
                        }
                      }}
                      action={`/api/rubusMaster/upload/devices?SiteId=${siteId}${AliasCode && AliasCode !== null ? `&ModuleCode=${AliasCode}` : ''
                        }${AliasCode === null ? `&Type=${'NoModule'}` : ''}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <UploadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black', marginRight: '10px' }}>
                        {' '}
                        {translation(translationCache, 'Upload')}
                      </span>
                    </Upload>
                  </Form.Item>
                </>
              </div>
            </Form>
          </TabPane>

          <TabPane tab={translation(translationCache, 'Attributes')} key="Attributes">
            <Form
              name="AttributeForm"
              ref={AttributeFormRef}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '130px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <>
                  <Form.Item
                    name="Download Attributes"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'DownloadAttributes')}
                  >
                    <a href={`${IPAddress.LOCAL}${AttributeFileName}`}>
                      <DownloadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black' }}>Download</span>
                    </a>
                  </Form.Item>

                  <Form.Item
                    name="Upload Attributes"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'UploadAttributes')}
                  >
                    <Upload
                      multiple={false}
                      style={{ marginRight: '10px', color: 'white' }}
                      onChange={async (info) => {
                        if (info.file.status === 'done') {
                          message.success(info.file.response.message);
                          getAttributeFileDownloadName(AliasCode);
                          setModalVisible(false);
                        } else if (info.file.status === 'error') {
                          message.error(info.file.response.message);
                        }
                      }}
                      action={`/api/rubusMaster/upload/attributes?SiteId=${siteId}${AliasCode && AliasCode !== null ? `&ModuleCode=${AliasCode}` : ''
                        }${AliasCode === null ? `&Type=${'NoModule'}` : ''}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <UploadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black', marginRight: '10px' }}>
                        {' '}
                        {translation(translationCache, 'Upload')}
                      </span>
                    </Upload>
                  </Form.Item>
                </>
              </div>
            </Form>
          </TabPane>

          <TabPane tab={translation(translationCache, 'Parameters')} key="Parameters">
            <Form
              name="ParameterForm"
              ref={ParameterFormRef}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '130px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <>
                  <Form.Item
                    name="Download Parameters"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'DownloadParameters')}
                  >
                    <a href={`${IPAddress.LOCAL}${ParameterFileName}`}>
                      <DownloadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black' }}>{translation(translationCache, 'Download')}</span>
                    </a>
                  </Form.Item>

                  <Form.Item
                    name="Upload Attributes"
                    style={{ width: '50%' }}
                    label={translation(translationCache, 'UploadParameters')}
                  >
                    <Upload
                      multiple={false}
                      style={{ marginRight: '10px', color: 'white' }}
                      onChange={async (info) => {
                        if (info.file.status === 'done') {
                          message.success(info.file.response.message);
                          getParameterFileDownloadName(AliasCode);
                          setModalVisible(false);

                        } else if (info.file.status === 'error') {
                          message.error(info.file.response.message);
                        }
                      }}
                      action={`/api/rubusMaster/upload/parameters?SiteId=${siteId}${AliasCode && AliasCode !== null ? `&ModuleCode=${AliasCode}` : ''
                        }${AliasCode === null ? `&Type=${'NoModule'}` : ''}`}
                      headers={{
                        Authorization: Authorization
                      }}
                      showUploadList={false}
                    >
                      <UploadOutlined
                        style={{ color: 'black', marginRight: '1px' }}
                      />
                      <span style={{ color: 'black', marginRight: '10px' }}>
                        {' '}
                        {translation(translationCache, 'Upload')}
                      </span>
                    </Upload>
                  </Form.Item>
                </>
              </div>
            </Form>
          </TabPane>
        </Tabs>
      </Modal>

      {/* Drawer for Add/Edit Device Types */}
      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update Device Types')
            : translation(translationCache, 'Add Device Types')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visible}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          {/* <Form.Item
                        label="Module Code"
                        name="ModuleCode"
                        rules={[{ required: true, message: 'Please Select ModuleCode' }]}
                      >
                        <Select
                          value={SelectedModulesCode}
                          placeholder="Please select Modules Code"
                          onChange={this.ModuleCodeSelection}
                        >
                          {ModuleCodes.map((value, index) => {
                            return (
                              <Option key={index} value={value.AliasCode}>
                                {value.Name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item> */}
          <Form.Item
            label={translation(translationCache, 'Code')}
            name="Code"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code !') }]}
          >
            <Input
              disabled={formObject && formObject.Id ? true : false}
              placeholder={translation(translationCache, 'Please enter Code')}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Name')}
            name="Name"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Name !') }]}
          >
            <Input placeholder="Please enter Name" />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Description')}
            name="Description"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Description !') }]}
          >
            <Input placeholder="Please enter Description" />
          </Form.Item>
          {/* <Form.Item
                        label={this.translation('Display Code')}
                        name="DisplayCode"
                        rules={[{ required: true, message: this.translation('Please enter DisplayCode') }]}
                      >
                        <Input placeholder={this.translation('Please enter DisplayCode')} />
                      </Form.Item> */}
          <Form.Item
            label={translation(translationCache, 'Status')}
            name="Status"
            rules={[{ required: true, message: translation(translationCache, 'Please select Status') }]}
          >
            <Select disabled={true} defaultValue={'Active'}>
              <Option value="Active">{'Active'}</Option>
            </Select>
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(DeviceTypes);
